import { AnswerAreaSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { computeOpacity } from '../../utils';
import { useEffectivePinComponentSettings } from '../../utils/pinTheme/PinThemeContext';

export interface AnswerAreaPinComponentProps {
  settings: AnswerAreaSettings;
  children?: React.ReactNode;
}

/**
 * Renders an answer-area pin component.
 * Make sure to include an answer-area content component in the children.
 */
export const AnswerAreaPinComponent: React.FC<AnswerAreaPinComponentProps> = ({ settings, children }) => {
  const answerAreaSettings = useEffectivePinComponentSettings('ANSWER_AREA', {
    settings,
  });
  return (
    <StyledAnswerAreaWrapper>
      <StyledAnswerAreaBackground
        style={{
          backgroundColor: answerAreaSettings.backgroundColor,
          opacity: computeOpacity(answerAreaSettings.transparency),
        }}
      />
      {children}
    </StyledAnswerAreaWrapper>
  );
};

const StyledAnswerAreaWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

const StyledAnswerAreaBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 16px;
`;
